import dayjs from 'dayjs'
import { Box, Typography } from '@mui/material'

/**
 * Secondary timeline marker for each report in the History drawer: shows time and event type
 * (e.g. "5:40 PM" + "Therapy"). Matches ConnectingLines style for a consistent timeline.
 */
const LABEL_COLORS = {
  Consultation: { bg: 'primary.main', contrast: 'primary.contrastText' },
  Therapy: { bg: '#0d9488', color: '#fff' },
  Assessment: { bg: '#2563eb', color: '#fff' },
  Screening: { bg: '#d97706', color: '#fff' },
}

/** Card-only content; shared by absolute and inline layouts */
function TimeLabelCard({ timeStr, colors, label }) {
  return (
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '92px',
        flexShrink: 0,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
        <Typography
          variant="caption"
          sx={{
            width: '100%',
            textAlign: 'center',
            py: 0.5,
            px: 1.25,
            fontWeight: 700,
            fontSize: '0.7rem',
            letterSpacing: '0.02em',
            bgcolor: colors.bg,
            color: colors.contrast ?? colors.color,
          }}
        >
          {timeStr}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 600,
            fontSize: '0.7rem',
            color: 'text.primary',
            py: 0.75,
            px: 1.25,
            textAlign: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      </Box>
  )
}

export default function ReportTypeMarker({ time, label, inline = false }) {
  const timeStr = time
    ? dayjs.utc(time).local().format('h:mm A')
    : '—'
  const colors = LABEL_COLORS[label] || { bg: 'grey.700', color: '#fff' }

  const card = <TimeLabelCard timeStr={timeStr} colors={colors} label={label} />

  if (inline) {
    return (
      <Box className="hide-on-print-only" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {card}
      </Box>
    )
  }

  return (
    <Box
      className="hide-on-print-only"
      sx={{
        position: 'absolute',
        right: '100%',
        mr: 2,
        top: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        zIndex: 1,
      }}
    >
      {card}
    </Box>
  )
}
